/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface Practice { 
    readonly id: number;
    name: string;
}
export const Practice_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Practice_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(1023),];


